import useSWR from 'swr';
import { enqueueSnackbar } from 'notistack';
import { useContext } from 'react';
import { ScoringContext } from '@/contexts/scoring/context';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import {
  SERVICE_ENDPOINT,
  fetchFromMTService,
} from '../fetcher/monitoringToolService';
import { HTTP_STATUS_CODE } from '../constants';
import { ApiError } from '../ApiError';

export const useIsScorerFixture = () => {
  const token = useAuthToken();
  const {
    state: { fixtureSummary },
  } = useContext(ScoringContext);

  const { data, error } = useSWR<boolean, ApiError>(
    token && fixtureSummary?.collectionId
      ? {
          token,
          endpoint: SERVICE_ENDPOINT.Collections(fixtureSummary.collectionId)
            .isMyCollection.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (
          e.status !== HTTP_STATUS_CODE.NOT_FOUND &&
          e.status !== HTTP_STATUS_CODE.UNAUTHORIZED
        ) {
          return enqueueSnackbar(e.title, { variant: 'error' });
        }
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
    },
  );

  return {
    data,
    error,
    isLoading: data === undefined && !error,
  };
};
